@if (messages().length) {
  <ul class="flex flex-col gap-1 font-brand" role="alert">
    @for (message of messages(); track message.id) {
      <li
        class="text-13 tracking-tight"
        [ngClass]="{
          'text-danger-400': message.type === 'error',
          'text-zinc-400': message.type !== 'error',
        }">
        {{ 'kratosMessages.' + message.id | transloco: message.context }}
      </li>
    }
  </ul>
}
